class PAVinLookupCtrl {

    constructor($scope, VinLookupEnabled, VinLookupService, $q, VehicleImageLookupService, $filter, OLDEST_CAR_YEAR) {

        $scope.errorMsg = '';
        $scope.invalidVIN = null;
        $scope.years = [];
        const currentYear = new Date().getUTCFullYear();

        for (let i = currentYear; i > OLDEST_CAR_YEAR; i--) {
            $scope.years.push(i);
        }

        $scope.$watch('invalidVIN', (newValue) => {
            $scope.readonly = newValue === false;
            $scope.errorMsg = '';
        });

        $scope.lookupVIN = () => {
            if (VinLookupEnabled) {
                $scope.invalidVIN = null;
                if ($scope.vehicle.vin.value && $scope.vehicle.vin.value.length > 0) {
                    $scope.readonly = true;
                    $scope.vinLoaded = false;
                    $q.when(VinLookupService.autofillBasedOnVIN($scope.vehicle.vin.value), (vehicleInfo) => {
                        if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year) {
                            // Autofill with the returned data
                            $scope.invalidVIN = false;
                            this.constructor.autofillVehicleFromLookup($scope.vehicle, vehicleInfo);
                            $scope.errorMsg = '';
                        } else {
                            // The VIN does not return a match, VIN is invalid
                            $scope.invalidVIN = true;
                            this.constructor.setBlankValuesOnVehicle($scope.vehicle);
                            $scope.vehicleImageUrl = undefined;
                        }
                        $scope.vinLoaded = true;
                    }, () => {
                        // Something has gone legitimately wrong, let the user input the data manually
                        $scope.errorMsg = $filter('translate')('quoteandbind.pa.directives.PAEditVehicle.errorMsg'); // POR-2061
                        $scope.readonly = false;
                        $scope.vinLoaded = true;
                        $scope.invalidVIN = null;
                    });
                } else {
                    $scope.readonly = false;
                    $scope.errorMsg = '';
                    this.constructor.setBlankValuesOnVehicle($scope.vehicle);
                }
            }
        };

        $scope.$watchCollection('[vehicle.make.value, vehicle.model.value, vehicle.year.value]', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if ($scope.vehicle.make.value && $scope.vehicle.model.value && $scope.vehicle.year.value) {
                    $q.when(VehicleImageLookupService.lookupPhoto($scope.vehicle.value)
                        .then(url => {
                            if (url) {
                                $scope.$applyAsync(() => {
                                    $scope.vehicleImageUrl = url;
                                });
                            } else {
                                $scope.$applyAsync(() => {
                                    $scope.vehicleImageUrl = undefined;
                                });
                            }
                        }));
                }
                $scope.errorMsg = '';
            }
        });
    }

    static autofillVehicleFromLookup(vehicle, vehicleData) {
        vehicle.make.value = vehicleData.make;
        vehicle.model.value = vehicleData.model;
        vehicle.year.value = vehicleData.year;
    }

    static setBlankValuesOnVehicle(vehicle) {
        vehicle.make.value = '';
        vehicle.model.value = '';
        vehicle.year = undefined;
    }
}

PAVinLookupCtrl.$inject = ['$scope', 'VinLookupEnabled', 'VinLookupService', '$q', 'VehicleImageLookupService', '$filter', 'OLDEST_CAR_YEAR'];

export default PAVinLookupCtrl;